export class CompanyListItem {
  listType?: string; // Set on server side if sent from client
  constructor(
    public company: string,
    public value: string,
    public customBoolean1: boolean,
  ) {}
}
